<template>
  <div class="Applylist">
    <router-link :to="'/pay/'+payId  + '/0'">
      <div
        class="aListitem"
        v-for="(item,index) in hosInfos"
        :key="hosInfos+index"
        @click="infoToInformation(index)"
      >
        <div class="aitemleft">
          <div class="aitemimg">
            <img v-if="item.requestStatus===1" src="../assets/review.png" alt />
            <img v-if="item.requestStatus===2" src="../assets/review.png" alt />
            <img v-if="item.requestStatus===3" src="../assets/review.png" alt />
            <img v-if="item.requestStatus===4" src="../assets/wait_pay.png" alt />
            <img v-if="item.requestStatus===5" src="../assets/had_pay.png" alt />
            <img v-if="item.requestStatus===6" src="../assets/had_pay.png" alt />
            <img v-if="item.requestStatus===7" src="../assets/complete.png" alt />
            <img v-if="item.requestStatus===101" src="../assets/review_fail.png" alt />
            <img v-if="item.requestStatus===102" src="../assets/user_cancel.png" alt />
            <img v-if="item.requestStatus===103" src="../assets/user_cancel.png" alt />
            <img v-if="item.requestStatus > 103" src="../assets/review_fail.png" alt />
          </div>
          <div class="aitemtext">
            <span v-if="item.requestStatus===1">业务受理</span>
            <span v-if="item.requestStatus===2">业务受理</span>
            <span v-if="item.requestStatus===3">业务受理</span>
            <span v-if="item.requestStatus===4">未支付</span>
            <span v-if="item.requestStatus===5">已付款</span>
            <div
              v-if="item.userGetPrintType ===1 || item.userGetPrintType === 3 || item.userGetPrintType === 5 || item.userGetPrintType === 7 || item.userGetPrintType === 8"
            >
              <span v-if="item.requestStatus===6">已付款</span>
              <span v-if="item.requestStatus===7">已邮寄</span>
            </div>
            <div
              v-if="item.userGetPrintType ===2 || item.userGetPrintType === 4 || item.userGetPrintType === 6 || item.userGetPrintType === 9"
            >
              <span v-if="item.requestStatus===6">可自提</span>
              <span v-if="item.requestStatus===7">已完成</span>
            </div>
            <span v-if="item.requestStatus===101">审核不通过</span>
            <span v-if="item.requestStatus===102">用户取消</span>
            <span v-if="item.requestStatus===103">用户取消并退款</span>
            <span v-if="item.requestStatus===104">申请异常</span>
            <span v-if="item.requestStatus===105">申请异常关闭</span>
            <span v-if="item.requestStatus===106">系统关闭申请</span>
            <span v-if="item.requestStatus===107">申请超时</span>
          </div>
        </div>
        <div class="aitemright">
          <!-- 上 -->
          <div class="aitemtop">
            <div class="pname">
              <div>{{item.patientName}}</div>
              <div v-if="item.isPrintInvoice && item.voucherStatus == 2 && item.requestStatus===7">
                <div class="ofapiao">发票已开</div>
              </div>
            </div>
            <div
              class="inhostime"
            >{{item.userHosInDate!=null?(item.userHosInDate).split(' ')[0]:''}}({{dateName}})</div>
          </div>
           <!-- 中 -->
          <div class="aitembottom">
            <div class="hosname">{{item.hosShortName}}</div>
            
            <!-- <div class="applytype">{{item.subType3Name}}</div> -->
          </div>
           <!-- 下 -->
          <div class="aitemmiddle aitembottom">
            
            <div class="applytype">{{item.subType3Name}}</div>
            <!-- <div class="hosname">{{item.hosShortName}}</div> -->
          </div>
        </div>
      </div>
    </router-link>

    <!-- <div class="delbtn">
      <button class="delorderbutton" v-if="true" @click="delOrderButton()">删除订单</button>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "ApplyList",
  data() {
    return {
      // applyHosList:[
      //     {'name':'刘雷冲','hosname':'河南省人民医院河南省人民医院河南省人民医院','inhostime':'2020-10-18','type':'微信住院病历预约自提' ,'requestStatus': 1,'userGetPrintType':3},
      //     {'name':'刘雷冲','hosname':'河南省人民医院','inhostime':'2020-10-30','type':'微信住院病历邮寄','requestStatus': 2,'userGetPrintType':3},
      //     {'name':'刘雷冲','hosname':'郑州大学第一附属医院','inhostime':'2020-10-18','type':'微信住院病历邮寄','requestStatus': 3,'userGetPrintType':3},
      //     {'name':'刘雷冲','hosname':'郑州大学第一附属医院','inhostime':'2020-10-18','type':'微信住院病历预约自提','requestStatus': 4,'userGetPrintType':3},
      //     {'name':'刘雷冲','hosname':'濮阳市油田总医院','inhostime':'2020-10-18','type':'微信住院病历预约自提','requestStatus': 5,'userGetPrintType':3},
      //     {'name':'刘雷冲','hosname':'濮阳市油田总医院','inhostime':'2020-10-18','type':'微信住院病历邮寄','requestStatus': 6,'userGetPrintType':3},
      //     {'name':'刘雷冲','hosname':'河南胸科医院','inhostime':'2020-10-18','type':'微信住院病历预约自提','requestStatus': 7,'userGetPrintType':3},
      // ],
      hosInfos: [],
      payId: "",
      dateName: "入院",
      voucherStatus:'',
      isPrintInvoice:false
    };
  },
  created() {
    let wxId = localStorage.getItem("wxId");
    let userId = localStorage.getItem("userId");
    if (wxId == "13") {
      this.dateName = "就诊";
    }
    const params = {
      wxId: wxId,
      userId: userId
    };
    this.getRequestList(params);
  },
  mounted() {
    // var params = {
    //   wxId: 12,
    //   userId: 1363
    // };
    // this.getRequestList(params);
  },
  methods: {
    getRequestList(params) {
      this.$server.getRequestList(params).then(data => {
        if (data.result == 1) {
          this.hosInfos = data.requests;
          console.log('0000')
          console.log(this.hosInfos)
          console.log('1111')
          this.isPrintInvoice = this.hosInfos.isPrintInvoice;
          this.voucherStatus = this.hosInfos.voucherStatus;
        } else if (data.result == 200) {
          // console.log("2")
        }
      });
    },
    infoToInformation(index) {
      this.payId = this.hosInfos[index].requestId;
    },
    // delOrderButton(){
    //   this.$router.push('/deleteorder' + '?del=' + 'delorder')
    // }
  }
};
</script>
<style>
.Applylist {
  width: 100%;
  /* height: 100vh; */
  background: #f5f8fa;
}
.aListitem {
  /* width: 100%; */
  display: flex;
  background: white;
  margin-bottom: 10px;
  padding: 10px 20px;
}
.aitemleft {
  flex: 2;
  margin-top: 18px;
}
.aitemimg img {
  width: 40px;
  height: 40px;
  margin-left: 5px;
}
.aitemtext {
  width: 50px;
  word-wrap: wrap;
  font-size: 12px;
  color: #007aff;
  text-align: center;
  line-height: 14px;
  margin-top: 6px;
}
.aitemright {
  flex: 8;
  overflow: hidden;
  margin-top: 10px;
}
.aitemtop {
  display: flex;
  margin-bottom: 6px;
  flex-direction: row;
  justify-content: space-between;
}
.pname {
  color: #333333;
  margin-right: 20px;
  display: flex;
  font-size: 18px;
  font-weight: 400;
}
.hosname {
  color: #333333;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.inhostime {
  color: #666666;
  font-size: 14px;
  line-height: 26ox;
  padding-top: 3px;
}
.aitembottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 6px;
}
.applytype {
  font-size: 10px;
  border: 1px solid #007aff;
  padding: 1px 4px;
  border-radius: 3px;
  color: #007aff;
  text-align: right;
}
.ofapiao{
  line-height: 12px;
  border: 1px solid #FE6F75;
  background: #FAEBEC;
  font-size: 12px;
  width: 50px;
  padding: 2px 2px;
  border-radius: 2px;
  color: #FE6F75;
  margin: 5px 8px;
}
.delbtn{
  width: 100%;
  text-align: center;
    background-color: #efeff4;
}
.delorderbutton{
  width: 80px;
  margin: 20px auto;
  font-size: small;
  color: #2fb42e;
  border: 1px solid #ccced1;
  padding:5px 10px;
  border-radius: 5px;

}
</style>


